import type { SVGProps } from "react"
import React from "react"

export const ArrowRight: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 16,
  height = 16,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    />
  </svg>
)
